import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Grid from './Grid';
import { Heading } from '@miro-site/core';
import Highlighted from './Highlighted';
import SecondaryNavigationItem from './SecondaryNavigationItem';
import styled, { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TemplatesNavGrid = styled(Grid).withConfig({
  displayName: "TemplatesHighlighted__TemplatesNavGrid",
  componentId: "sc-2urkns-0"
})(["", ""], function (props) {
  return props.theme.normalizeStyles({
    marginBottom: 43
  });
});

var TemplatesHighilighted = function TemplatesHighilighted(props) {
  var popularTemplates = props.popularTemplates,
      navigationGroup = props.navigationGroup;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      $my: 5,
      $variant: "h4",
      children: navigationGroup.title
    }), /*#__PURE__*/_jsx(TemplatesNavGrid, {
      gutter: theme.header.grid.gutter,
      columns: [null, null, 2, 4, 6],
      children: navigationGroup.items.map(function (i) {
        return /*#__PURE__*/_jsx(Grid.Column, {
          columns: [null, null, 1, 2, 3],
          children: /*#__PURE__*/_jsx(SecondaryNavigationItem, {
            path: i.path,
            title: i.title,
            description: i.description
          }, i.title)
        }, i.title);
      })
    }), /*#__PURE__*/_jsx(Highlighted, _objectSpread({}, popularTemplates))]
  });
};

export default TemplatesHighilighted;